// packages/shared/src/rules/lookup.ts
import { getEntry, type CatalogEntry, type CatalogId } from '@whiskerton/content';
export type Lookup = (id: CatalogId) => CatalogEntry | undefined;
export const catalogLookup: Lookup = getEntry;
export function lookupFrom(entries: readonly CatalogEntry[]): Lookup {
  const m = new Map(entries.map((e) => [e.id, e]));
  return (id) => m.get(id);
}
